import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import {
  type ResolvedTheme,
  type ThemeMode,
  getStoredThemeMode,
  resolveTheme
} from '@/shared/services/theme';

const initialThemeMode = getStoredThemeMode();

const initialState: IAppState = {
  headerConfig: {
    showElements: {
      header: true,
      langSelector: true
    },
    title: '',
    subtitle: '',
    helmetTitle: ''
  },
  // themeMode — выбор пользователя; theme — эффективная схема (для system из matchMedia).
  themeMode: initialThemeMode,
  theme: resolveTheme(initialThemeMode)
};

export type TAppState = typeof initialState;

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setHeaderConfig: (
      state,
      action: PayloadAction<Partial<IAppState['headerConfig']>>
    ) => {
      state.headerConfig = {
        ...initialState.headerConfig,
        ...action.payload,
        showElements: {
          ...initialState.headerConfig.showElements,
          ...(action.payload.showElements ?? {})
        }
      };
    },
    /** Сменить режим темы (выбор пользователя) + сразу эффективную схему. */
    setThemeMode: (
      state,
      action: PayloadAction<{ mode: ThemeMode; theme: ResolvedTheme }>
    ) => {
      state.themeMode = action.payload.mode;
      state.theme = action.payload.theme;
    },
    /** Обновить только эффективную схему (например, при смене системной темы в режиме system). */
    setTheme: (state, action: PayloadAction<ResolvedTheme>) => {
      state.theme = action.payload;
    }
  }
});

export const { setHeaderConfig, setThemeMode, setTheme } = appSlice.actions;
export default appSlice;

interface IAppState {
  headerConfig: {
    title: string;
    subtitle: string;
    helmetTitle: string;
    /** Кнопка «назад» в шапке у вложенных экранов: путь из ROUTES и подпись родителя для aria-label. */
    back?: { to: string; label: string };
    showElements: {
      header?: boolean;
      langSelector?: boolean;
    };
  };

  themeMode: ThemeMode;
  theme: ResolvedTheme;
}
